export default "__VITE_ASSET__BIf04dYO__"